import { useAppStore } from '@/core/store'

const SCENE_LABEL: Record<string, string> = {
  forest: '森林',
  ocean: '海洋',
  menu: '主菜单',
}

export function HUD() {
  const currentScene = useAppStore((s) => s.currentScene)
  const fps = useAppStore((s) => s.fps)
  const goToScene = useAppStore((s) => s.goToScene)

  if (currentScene === 'menu') return null

  return (
    <div
      style={{
        position: 'absolute',
        top: 12,
        left: 12,
        right: 12,
        display: 'flex',
        justifyContent: 'space-between',
        color: '#cfe7ff',
        fontFamily: 'system-ui, sans-serif',
        fontSize: 14,
        pointerEvents: 'none',
        zIndex: 5,
      }}
    >
      <div
        style={{
          background: 'rgba(0,0,0,0.45)',
          padding: '6px 12px',
          borderRadius: 6,
          pointerEvents: 'auto',
        }}
      >
        场景：{SCENE_LABEL[currentScene] ?? currentScene} · FPS: {Math.round(fps)}
      </div>
      <button
        type="button"
        onClick={() => goToScene('menu')}
        style={{
          background: 'rgba(0,0,0,0.45)',
          border: '1px solid rgba(255,255,255,0.2)',
          color: 'inherit',
          padding: '6px 14px',
          borderRadius: 6,
          cursor: 'pointer',
          pointerEvents: 'auto',
        }}
      >
        返回菜单 (Esc)
      </button>
    </div>
  )
}
